import Vue from "vue";
import VueTailwind from "vue-tailwind";

import VueTailwindSettings from "./plugins/VueTailwind";

import App from "./App.vue";
import router from "./router";
import store from "./store";

import "./scss/index.scss";

import "./plugins/VeeValidate";

Vue.config.productionTip = false;

Vue.use(VueTailwind, VueTailwindSettings);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
